<template>
  <svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" class="align-self-center lung-svg" style="width: 100px; height: 100px">
    <defs>
      <!-- Clipping-Maske basierend auf den äußeren Pfaden der Lunge -->
      <clipPath id="lungClip">
        <path
          d="M42.17 20.59C33.54 20.62 13.64 33.83 6.7 64s.33 48.53 22.52 50.25c21.77 1.69 28.24-13.56 29.22-18.81c2.88-15.35.25-40.88-2.75-54.77s-4.93-20.11-13.52-20.08z" />
        <path
          d="M86.49 21.46c8.53-.04 28.19 13.14 35.05 43.05c6.86 29.92-.32 48.13-22.25 49.83c-7 .54-12.39.3-16.52-1.79c-3.89-3.38-2.48-11.06-4.29-19.3c-.87-3.98-5.16-8.8-9.26-11.31c-.24-14.03 1.74-30.43 3.93-40.58c2.96-13.76 5.06-19.86 13.34-19.9z" />
      </clipPath>
    </defs>

    <!-- Gesamte Lunge mit Pulsanimation -->
    <g id="lungGroup" class="lung-pulse">
      <path
        d="M42.17 20.59C33.54 20.62 13.64 33.83 6.7 64s.33 48.53 22.52 50.25c21.77 1.69 28.24-13.56 29.22-18.81c2.88-15.35.25-40.88-2.75-54.77s-4.93-20.11-13.52-20.08z"
        fill="#fea8a7"
        class="gradient-shift" />
      <path
        d="M73.29 92.99c1.19 5.17 1 9.47 3.52 13.94c3.1 5.49 7.89 6.33 7.89 6.33l-4.23-23.65l-9.71-10.14l-1.54 2.55c-.01.01 2.99 6.29 4.07 10.97z"
        fill="#fed0b0" />
      <path
        d="M86.49 21.46c8.53-.04 28.19 13.14 35.05 43.05c6.86 29.92-.32 48.13-22.25 49.83c-7 .54-12.39.3-16.52-1.79c-3.89-3.38-2.48-11.06-4.29-19.3c-.87-3.98-5.16-8.8-9.26-11.31c-.24-14.03 1.74-30.43 3.93-40.58c2.96-13.76 5.06-19.86 13.34-19.9z"
        fill="#fea8a7"
        class="gradient-shift" />
      <linearGradient id="IconifyId17ecdb2904d178eab10003" gradientUnits="userSpaceOnUse" x1="38.285" y1="33.945" x2="32.938" y2="71.984">
        <stop offset=".294" stop-color="#fea8a7" />
        <stop offset=".548" stop-color="#fea4a2" />
        <stop offset=".827" stop-color="#fe9895" />
      </linearGradient>
      <path
        d="M8.04 58.89s5.7 8.34 21.93 12.29s29.58 1.69 29.58 1.69s-.9-16.07-2.38-24.13s-16.31-14.73-19.22-14.83s-17.1.36-17.1.36s-4.35 5.18-7.09 10.49c-2.93 5.7-5.72 14.13-5.72 14.13z"
        fill="url(#IconifyId17ecdb2904d178eab10003)" />
      <linearGradient id="IconifyId17ecdb2904d178eab10004" gradientUnits="userSpaceOnUse" x1="43.735" y1="72.591" x2="15.601" y2="96.199">
        <stop offset=".404" stop-color="#fea8a7" />
        <stop offset=".609" stop-color="#fea3a1" />
        <stop offset=".824" stop-color="#fe9895" />
      </linearGradient>
      <path
        d="M4.56 76.53s8.61 9.38 13.03 16.05s13.21 21.73 13.21 21.73s10.06 1 17.74-4.25c4.88-3.35 8.34-5.43 10.09-15.66s-18.8-15.44-22.09-15.53c-3.28-.09-18.91-8.75-20.98-11.04s-8.08-6.74-8.08-6.74s-1.31 5.14-1.63 6.84c-.31 1.69-1.29 8.6-1.29 8.6z"
        fill="url(#IconifyId17ecdb2904d178eab10004)" />
      <linearGradient id="IconifyId17ecdb2904d178eab10005" gradientUnits="userSpaceOnUse" x1="85.299" y1="61.807" x2="106.486" y2="94.432">
        <stop offset=".352" stop-color="#fea8a7" />
        <stop offset=".794" stop-color="#fe9b99" />
        <stop offset=".893" stop-color="#fe9895" />
      </linearGradient>
      <path
        d="M80.45 108.47s6.49-.23 20.48-10.74s21.77-27.56 21.77-27.56s-1.15-5.73-1.56-7.3c-.4-1.57-20.78.97-26.03 2.76c-5.26 1.78-25.68 6.48-25.68 6.48s-.24 9.49-.22 9.92c.26.02 6.92 5.41 8.21 8.63c1.78 4.44 1.89 9.34 2.03 11.53c.19 2.88 1 6.28 1 6.28z"
        fill="url(#IconifyId17ecdb2904d178eab10005)" />
      <path
        d="M21.24 54.84c-1.03-.75-2.53-2.25-1.69-3.28c.84-1.03 3.1.38 4.22 1.22c1.13.84 3.1 2.44 3.1 2.44l8.54-1.03s-7.04-6.1-8.35-7.23c-1.31-1.13-4.13-3.38-2.91-4.69c1.22-1.31 3.47.84 4.69 1.97c1.22 1.13 9.39 7.32 9.39 7.32s-1.78-5.91-2.35-7.7c-.56-1.78-2.16-5.35-.47-6.01c1.69-.66 2.72 2.91 3.57 4.88c.84 1.97 5.82 13.42 5.82 13.42s1.88 2.11 3.66 1.1c1.78-1.01 11.22-11.24 11.22-11.24l-.13-34.73s1.67-.66 4.02-.75s4.41.75 4.41.75l.38 34.91s9.01 10.7 10.98 11.07s3.57.75 4.5 0c.94-.75 7.23-11.07 7.79-12.86c.56-1.78-1.31-7.04 0-7.79s2.16 1.41 2.63 3c.47 1.6 1.03 3.28 1.03 3.28s2.06-.47 3.28-.84c1.22-.38 2.82-.38 3 .56c.19.94-2.91 2.53-4.32 3.47c-1.41.94-3.66 1.69-3.28 3.19s3.38 1.03 5.44 1.13c2.06.09 3.38.38 3.38 1.5c0 1.13-3.19 1.66-5.73 1.77c-2.53.11-5.91 0-5.91 0s-1.88 3.13-1.88 4.01s5.26 1.54 8.35 2.1c3.1.56 10.14 1 10.04 2.61c-.09 1.61-2.5 1.43-4.13 1.57c-1.63.14-5.69-.89-5.63 0c.06.89 3.75 4.36 2.25 5.3c-1.5.94-3.66-2.25-5.07-3.66s-2.35-2.25-2.35-2.25s-12.17.14-12.27.65c-.09.51 7.7 10.65 9.1 11.12c1.41.47 8.26 1.69 10.7 2.06c2.44.38 4.88 1.13 4.69 2.3c-.19 1.17-3.1 1.08-5.07 1.08h-5.35s6.48 5.74 7.88 7.37s7.04 6.23 5.26 7.55c-1.78 1.31-9.24-6.18-11-7.55s-5.99-4.56-6.36-4.19s2.63 5.35 3.28 6.57s3.41 5.16 1.38 6.05C93.39 97.05 89 89 88.43 89c-.56 0-.84 8.26-2.25 7.88s-1.5-3.28-1.69-8.35c-.19-5.07.84-7.88-.28-9.06c-1.13-1.17-5.73-9.15-7.51-10.56S64 57.28 64 57.28S52.68 67.42 50.34 69.3c-2.35 1.88-6.85 5.54-7.32 6.48s-1.13 4.04-1.03 5.16c.09 1.13 3.1 8.17 3.66 9.29c.56 1.13 2.44 5.26.94 5.73s-3.38-3.57-4.13-4.79c-.75-1.22-2.63-4.41-2.63-4.41s-1.69 7.5-2.44 9.62c-.75 2.11-2.44 8.68-4.32 7.46c-1.88-1.22-.94-4.23 0-7.46c.94-3.23 1.69-5.86 1.6-6.24s-6.48 3.19-7.7 4.04c-1.22.84-4.69 3-5.54 1.5c-.84-1.5 3-3.94 4.41-4.88s10.32-6.57 10.32-6.57s.09-1.03.66-3.66s.75-4.22.75-4.22l-5.83.28s-3.46 3.28-4.4 4.32c-.94 1.03-3.1 3.75-3.94 2.35c-.84-1.41 3-5.63 3-5.63s-2.82-.19-4.22-.09c-1.41.09-3.1.19-3.19-1.13c-.09-1.31 5.07-2.38 7.6-2.93s11.26-2.42 11.26-2.42l7.6-7.08s-5.26-5.5-6.1-5.59c-.84-.09-10.98.56-10.98.56s-2.06 1.88-3 2.82s-2.53 3.3-3.75 2.21c-1.22-1.09.19-2.59.94-3.62l1.6-2.71"
        fill="#fee5c3"
        class="inner-details" />
      <linearGradient id="IconifyId17ecdb2904d178eab10006" gradientUnits="userSpaceOnUse" x1="63.07" y1="7.537" x2="63.07" y2="69.609">
        <stop offset=".31" stop-color="#fed3b3" />
        <stop offset=".647" stop-color="#fed5b5" />
        <stop offset=".769" stop-color="#fedcbb" />
        <stop offset=".841" stop-color="#fee5c3" />
      </linearGradient>
      <path
        d="M48.46 57.26c1.78-1.01 11.22-11.24 11.22-11.24l-.13-37.73s1.67-.66 4.02-.75c2.35-.09 4.41.75 4.41.75l.38 37.91s9.01 10.7 10.98 11.07s1.22 6.21 1.13 6.72c-.09.51-1.97 6.33-3.75 4.92S64 57.28 64 57.28S52.68 67.42 50.34 69.3c-2.35 1.88-4.88-5.3-4.88-5.3s1.22-5.73 3-6.74z"
        fill="url(#IconifyId17ecdb2904d178eab10006)"
        class="inner-details" />
      <path
        d="M58.15 34.92c.01 2.25 2.05 2.04 5.85 2.04s5.69.22 5.7-2.04c.01-2.6-2.25-2.11-5.77-2.11c-3.53 0-5.79-.35-5.78 2.11z"
        fill="#f2a159"
        class="bronchioles" />
      <path
        d="M58.23 28.24c.01 2.25 2.05 2.04 5.85 2.04s5.69.22 5.7-2.04c.01-2.6-2.25-2.11-5.77-2.11c-3.53-.01-5.79-.36-5.78 2.11z"
        fill="#f2a159"
        class="bronchioles" />
      <path
        d="M58.23 21.55c.01 2.25 2.05 2.04 5.85 2.04s5.69.22 5.7-2.04c.01-2.6-2.25-2.11-5.77-2.11c-3.53 0-5.79-.36-5.78 2.11z"
        fill="#f2a159"
        class="bronchioles" />
      <path
        d="M58.23 15.07c.01 2.25 2.05 2.04 5.85 2.04s5.69.22 5.7-2.04c.01-2.6-2.25-2.11-5.77-2.11c-3.53 0-5.79-.35-5.78 2.11z"
        fill="#f2a159"
        class="bronchioles" />
    </g>

    <!-- Overlay: Animierter Füllstand -->
    <g clip-path="url(#lungClip)">
      <rect x="0" y="0" width="128" :height="unfilledHeight" fill="white" opacity="0.8" class="fill-overlay" />
    </g>
  </svg>
</template>

<script>
export default {
  name: "LungFillSvg",
  props: {
    percentage: {
      type: Number,
      default: 70,
      validator: (value) => value >= 0 && value <= 100,
    },
  },
  computed: {
    unfilledHeight() {
      return 128 * (1 - this.percentage / 100)
    },
  },
}
</script>

<style scoped>
/* Pulsating animation */
.lung-pulse {
  animation: breathe 2s ease-in-out infinite;
}

/* Gradient shift animation für äußere Lunge */
.gradient-shift {
  animation: colorShift 5s ease-in-out infinite;
}

/* Subtile Animation für innere Details */
.inner-details {
  animation: innerGlow 4s ease-in-out infinite;
}

/* Animation für Bronchiolen */

/* Filling animation */
.fill-overlay {
  animation: fillUp 3s ease-in-out infinite alternate;
}

@keyframes breathe {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes colorShift {
  0% {
    fill: #fea8a7;
  }
  50% {
    fill: #ff6f61; /* Cooler coral tone */
  }
  100% {
    fill: #fea8a7;
  }
}

@keyframes innerGlow {
  0% {
    fill: #fee5c3;
    opacity: 0.9;
  }
  50% {
    fill: #fff3d1;
    opacity: 1;
  }
  100% {
    fill: #fee5c3;
    opacity: 0.9;
  }
}

@keyframes pulseBronchioles {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes fillUp {
  0% {
    height: 128px; /* Vollständig ungefüllt */
    opacity: 0.8;
  }
  100% {
    height: 0px; /* Vollständig gefüllt */
    opacity: 0.2;
  }
}

.lung-svg {
  overflow: visible; /* Damit die Animation nicht abgeschnitten wird */
}
</style>
